export enum ActivationTypeEnum {
    Active = 1,
    DeActive = 2,
    All = 3
}